export const HOME = "/";
export const CURRENCY = "/currencies";
export const CURRENCY_DETAILS = "/currency/detail/:coinId";
export const STATS = "/statistics";
export const EXCHANGE = "/exchange";
export const NEWS = "/news";
